import { useRouter } from 'next/router'
import { FormEvent, useCallback } from 'react'

import { validatePhoneNumber } from '@/util/validation'

const downloadAppForm = process.env.NEXT_PUBLIC_FARMER_SOLUTION_FORM || '/form'

const useDownloadAppForm = () => {
  const { push } = useRouter()

  const onSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const mobileNumber = formData.get('mobile_number') as string
    const isMobileNumberValid = validatePhoneNumber(mobileNumber) == null
    if (isMobileNumberValid) {
      try {
        const newFormData = new FormData()
        newFormData.append('mobile_number', mobileNumber)
        await fetch(downloadAppForm, {
          method: 'POST',
          body: newFormData,
        })
        window.location.reload()
      } catch (e) {
        push(
          'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer&hl=hi&gl=US'
        )
        console.error(e)
      }
    } else {
      console.error('Invalid mobile number!')
    }
  }, [])

  return onSubmit
}

export default useDownloadAppForm
